import {
  PickerValidDate,
  TimePicker,
  TimePickerProps,
} from '@mui/x-date-pickers';
import React, { FC, useState } from 'react';

import translate from '../../../i18n/translate';
import MaterialSymbolClockAltIcon from '../MuiIcon/MaterialSymbolIcon/ClockAlt';

type Props = TimePickerProps<PickerValidDate> & {
  isReadOnly?: boolean;
};

/**
 * Common time picker component
 *
 * @param props              Props passed to the component
 * @param props.isReadOnly   Whether the input should be readonly
 * @param props.requestClear Request that the time is cleared
 * @returns                  The component itself
 */
const PickerTime: FC<Props> = ({ isReadOnly = false, ...props }) => {
  const [open, setOpen] = useState(false);

  return (
    <TimePicker
      label={translate('DUE_DATE__LABEL_TIME')}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      slotProps={{
        field: {
          clearable: false,
          /**
           * Do nothing on keyboard input if picker is read-only
           *
           * @param event Event that took place
           */
          onKeyDown: isReadOnly
            ? event => {
                event.preventDefault();
              }
            : undefined,
        },
        textField: {
          InputLabelProps: {
            shrink: true,
          },
          /**
           * Open the time picker when the input is clicked
           */
          onClick: () => {
            if (props.disabled === true) {
              return;
            }
            setOpen(true);
          },
          slotProps: {
            htmlInput: {
              readOnly: isReadOnly,
            },
          },
        },
      }}
      slots={{ openPickerIcon: MaterialSymbolClockAltIcon }}
      {...props}
    />
  );
};
export default PickerTime;
